import { Grid, styled, Typography } from "@mui/material";

export const InputWrapper = styled((props) => (
	<Grid mb={16} container item alignItems="start" {...props} />
))();

export const InputLabel = styled(({ width = 100, ...rest }) => (
	<Typography pt={10} color="text.tertiary" width={width} {...rest} />
))();
